export interface IOrderHistory {
  orderId: number;
  orderOperationType: number;
  userType: number;
  userFullName: string;
  cellId: number;
  cellNumber: number;
  notes: string;
  created: Date | string;
  createdBy: number | string;
}

export enum OrderStatus {
  Concluded = 13001,
  Allocated = 13002,
  AwaitingAllocation = 13003,
  Cancelled = 13004,
  CancelledByAdmin = 13005,
  AwaitingSelection = 13006,
  SBSubscriptionOrdered = 13007,
  AwaitingPairing = 13008,
}

export enum PaymentStatus {
  Failure = 20001,
  Success = 20002,
  NotCharged = 20003,
  VoucherUsed = 20004,
}

export const enum AllocateOrder {
  CELL_UNAVIABLE = 9005,
}
